import React from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    type: 'spring',
    stiffness: 100,
    damping: 20
  }} className="fixed top-0 left-0 right-0 z-50 bg-white comic-border border-t-0 border-l-0 border-r-0 comic-shadow-sm" data-id="element-92">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <div className="flex justify-between items-center h-20" data-id="element-94">
          <div className="flex items-center" data-id="element-95">
            <a href="#" className="font-bangers text-4xl text-[#FFD700] text-stroke-black-sm italic tracking-wider" data-id="element-96">
              COMICUT
            </a>
          </div>
          <div className="hidden md:flex items-center space-x-8 font-bangers text-2xl tracking-wide" data-id="element-97">
            <a href="#features" className="text-black hover:text-[#1a5cff] transition-colors" data-id="element-98">
              Features
            </a>
            <a href="#how-it-works" className="text-black hover:text-[#1a5cff] transition-colors" data-id="element-99">
              How It Works
            </a>
            <a href="#showcase" className="text-black hover:text-[#1a5cff] transition-colors" data-id="element-100">
              Gallery
            </a>
          </div>
          <div className="flex items-center" data-id="element-101">
            <a href="#download" className="bg-[#FFD700] text-black font-bangers text-xl px-6 py-2 comic-border comic-shadow-sm hover:translate-y-1 hover:translate-x-1 hover:shadow-none transition-all" data-id="element-102">
              Download Free
            </a>
          </div>
        </div>
      </div>
    </motion.nav>;
}